export default {
  methods: {
    isAreaVisible(level1) {
      return level1.children.some((country) => {
        return this.isCountryVisible(country);
      });
    },
    isCountryVisible(level2) {
      if (!Array.isArray(this.featuredSearchStats)) {
        return false;
      }

      if (this.searchType === "liveaboard" || this.searchType === "resort") {
        return true;
      }

      if (Array.isArray(level2.children)) {
        // It's not always that we have destinations under the country
        const entries = this.featuredSearchStats.filter(
          (_entry) => _entry.country_code === level2.code
        );

        if (this.searchType === "ecoventure") {
          return entries.some((_entry) => _entry.has_ecoventures);
        } else if (this.searchType === "yacht") {
          return entries.some((_entry) => _entry.has_yacht);
        }

        return false;
      }

      for (const child of level2.children) {
        if (this.isDestinationVisible(child)) {
          return true;
        }
      }

      return false;
    },
    isDestinationVisible(level3) {
      if (!Array.isArray(this.featuredSearchStats)) {
        return false;
      }

      if (this.searchType === "liveaboard" || this.searchType === "resort") {
        return true;
      }

      const entries = this.featuredSearchStats.filter(
        (_entry) => _entry.destination_code === level3.code
      );

      let result = false;

      if (this.searchType === "ecoventure") {
        result = entries.some((_entry) => _entry.has_ecoventures);
      } else if (this.searchType === "yacht") {
        result = entries.some((_entry) => _entry.has_yacht);
      }

      if (Array.isArray(level3.children_codes)) {
        const entries = this.featuredSearchStats.filter((_entry) =>
          level3.children_codes.includes(_entry.destination_code)
        );

        if (entries.length) {
          if (this.searchType === "ecoventure") {
            result = entries.some((_entry) => _entry.has_ecoventures);
          }
        }
      }

      return result;
    },
    toggleLevel1() {
      $(".area-group").each(function () {
        let isVisible = false;

        $(this)
          .find(".featured-search-item-group-lvl1 > li")
          .each(function () {
            if ($(this).find("> p").hasClass("hidden") === false) {
              isVisible = true;
            }
          });

        if (isVisible) {
          $(this).removeClass("hidden");
        } else {
          $(this).addClass("hidden");
        }
      });
    },
  },
};
